import {Component, OnInit} from '@angular/core';
import {PriceRobotCompetitorService} from '../services/price-robot-competitor.service';
import {ActivatedRoute, Router} from '@angular/router';
import {PriceRobotUrl} from '../services/price-robot-url';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {PriceRobotCompetitor} from '../services/price-robot-competitor';
import {PriceRobotMessageService} from '../services/price-robot-message.service';
import {PriceRobotCrawlerUrlService} from '../services/price-robot-crawler-url.service';
import {combineLatest} from 'rxjs';

@Component({
    selector: 'app-price-robot-competitor',
    templateUrl: './price-robot-competitor.component.html',
    styleUrls: ['./price-robot-competitor.component.scss']
})
export class PriceRobotCompetitorComponent implements OnInit {

    public param: any;
    public competitor: any = null;
    public loading = false;
    public showFullUrl = false;
    public urls: PriceRobotUrl[] = [];
    public mode: 'pending' | 'approved' | 'error' = 'pending';
    public page: any;
    public meta: any;
    public queryParams: any = {}

    constructor(private priceRobotCompetitorService: PriceRobotCompetitorService,
                private priceRobotMessageService: PriceRobotMessageService,
                private priceRobotCrawlerUrlService: PriceRobotCrawlerUrlService,
                private route: ActivatedRoute,
                private modalService: NgbModal) {
    }

    ngOnInit(): void {
        combineLatest(
            [this.route.paramMap,
            this.route.queryParams]
        ).subscribe((result) => {
            const params = result[0];
            this.param = params.get('competitorId');
            this.priceRobotCompetitorService.view(this.param).subscribe(competorResult => {
                const data: any = competorResult;
                this.competitor = <PriceRobotCompetitor>data.competitor;
            }, error => {
                this.priceRobotMessageService.handleError(error);
            })

            const queryParams = result[1];
            this.queryParams = queryParams;
            if (queryParams.mode) {
                this.mode = queryParams.mode;
            }
            if (queryParams.page) {
                this.page = queryParams.page
            } else {
                this.page = 1;
            }
            this.loadUrls();
        });
    }

    loadUrls() {
        this.loading = true;
        this.urls = [];
        const filter = {
            approved: this.mode === 'approved' ? true : undefined,
            pending: this.mode === 'pending' ? true : undefined,
            error: this.mode === 'error' ? true : undefined,
            urlId: this.queryParams.urlId ?  this.queryParams.urlId : undefined,
        }
        this.priceRobotCompetitorService.getUrls(this.param, this.page, filter).subscribe(result => {
            const data: any = result;
            this.urls = this.getUrls(data.urls, true);
            this.meta = data.meta['CrawlerUrls'];
            this.loading = false;
        }, error => {
            this.priceRobotMessageService.handleError(error);
        })
    }


    getUrls(url: any, orig: boolean = false): PriceRobotUrl[] {
        let i = 0;
        const urlList: PriceRobotUrl[] = [];
        url.forEach((value: any) => {
            urlList[i] = PriceRobotUrl.fromJSON(value);
           // urlList[i].url = value.url;
           // urlList[i].id = value.id;
           // urlList[i].last_error = value.last_error;
           // urlList[i].last_log = value.last_log;
           // urlList[i].score = value.score;
           // urlList[i].screenshot_url = value.screenshot_url;
           // if (value.products.length > 0) {
           //     urlList[i].product_id = value.products[0].id;
           //     urlList[i].name = value.products[0].name;
           //     urlList[i].custom_fields = value.products[0].custom_fields;
           //     if (url.findIndex('ean') !== -1) {
           //         urlList[i].ean = value.products[0].custom_fields[url.findIndex('ean')].value;
           //     }
           //     if (orig && value.products && value.products[0].crawler_urls && value.products[0].crawler_urls.length > 0 && value.products[0].crawler_urls[0].crawler_logs.length > 0) {
           //         const obj = value.products[0].crawler_urls[0].crawler_logs[0].process_result;
           //         urlList[i].original_screenshot_url = obj[0].screenshotUrl
           //         urlList[i].orginal_id = value.products[0].crawler_urls[0].id;
           //     }
           // }
            i++;
        })
        return urlList;
    }

    edit(url: PriceRobotUrl = new PriceRobotUrl(), isApproved: boolean, hasError: boolean = false) {
        this.loading = true;
        url.is_approved = isApproved;
        url.has_error = hasError;
        this.priceRobotCompetitorService.editCrawlerUrl(this.param, url).subscribe(result => {
            this.modalService.dismissAll();
            this.loadUrls()
        }, error => {
            this.loading = false;
            this.priceRobotMessageService.setError(error.error);
            this.loadUrls()
        })
    }

    delete(url: PriceRobotUrl = new PriceRobotUrl()) {
        if (confirm('Er du sikker på du vil slette denne url?')) {
            this.loading = true;
            this.priceRobotCompetitorService.deleteCrawlerUrl(this.param, url).subscribe(result => {
                this.modalService.dismissAll();
                this.loadUrls()
            }, error => {
                this.priceRobotMessageService.handleError(error);
            })
        }
    }

    saveCompetitor() {
        this.loading = true;
        this.priceRobotCompetitorService.editCompetitor(this.competitor).subscribe(result => {
            this.modalService.dismissAll();
            this.loading = false;
        }, error => {
            this.priceRobotMessageService.handleError(error);
            this.loading = false;
        })
    }

    openModal(content: any) {
        this.modalService.open(content);
    }

    openLargeModal(content: any) {
        this.modalService.open(content, {size: 'xl'});
    }

    /**
     *
     * @param url
     */
    enqueue(url: PriceRobotUrl) {
        this.priceRobotCrawlerUrlService.enqueue(url.orginal_id).subscribe(result => console.log(result));
        this.priceRobotCrawlerUrlService.enqueue(url.id).subscribe(result => console.log(result));
    }
}
